import { render, staticRenderFns } from "./DrawerItemComponent.vue?vue&type=template&id=54a8b408"
import script from "./DrawerItemComponent.vue?vue&type=script&lang=js"
export * from "./DrawerItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports